export default "__VITE_ASSET__CRYiSBzj__"